<template>
  <v-container>
    <app-modal v-model="showModal" max-width="1200" persistent>
      <template v-slot:title>{{ title }}</template>
      <template v-slot:text>
        <div class="text-xs-center" v-show="showLoading">
          <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
          <h2>Loading...</h2>
        </div>
        <v-form v-model="valid" ref="form" lazy-validation v-show="!showLoading">
          <v-subheader class="headline">General</v-subheader>
          <ImporterGeneral :Title="title" :data="generalData" :ImporterType="ImporterType" @setGeneralData="setGeneralData" />
          <br>
          <v-divider></v-divider>
          <v-subheader class="headline">Shared</v-subheader>
          <v-layout>
            <v-flex xs6 pr-3>
              <v-text-field label="Station Name" v-model="StationName" :rules="nullRule">
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">info_outline</v-icon>
                    </template>
                    Importer would filter the files which contain the station name value in the file name for processing.
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs6 pl-3>
              <v-text-field label="Start Row Index" :rules="numRuleNoZero" v-model="StartRowIndex">
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">info_outline</v-icon>
                    </template>
                    The index of the row that the importer starts to extract data.
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
          <br>
          <v-divider></v-divider>
          <v-subheader class="headline">Mappings</v-subheader>
          <v-tabs v-model="model" dark grow>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1">
              <v-icon class="mr-1">storage</v-icon>{{AQUARIUS_SERVER_NG}}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="model">
            <v-tab-item value="tab-1">
              <v-btn class="success" @click="addLength(NGConfig)">
                <v-icon>add</v-icon>{{ $t('Button.Add') }}
              </v-btn>
              <v-layout v-for="(item, i) in NGConfig" :key="i">
                <v-flex xs6 pr-3>
                  <ImporterTimeSeriesSelector v-model="NGConfig[i].TimeSeries" :serverType="AQUARIUS_SERVER_NG" :config="NGConfig" />
                </v-flex>
                <v-flex xs6 pl-3>
                  <v-text-field :label="columnIndex" :rules="linkRuleNG" v-model="NGConfig[i].Index"></v-text-field>
                </v-flex>
                <v-btn small icon class="icon_border" style="margin-top:15px" @click="subtractLength(i,NGConfig)">
                  <v-icon color="delete">clear</v-icon>
                </v-btn>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
          <ImporterAlert :AlertNG="AlertNG" />
        </v-form>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="save()" :disabled="!canSave" :loading="btnLoading">
          <v-icon>done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" @click="close()" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <app-confirmation-modal v-model="saveFailed" max-width="500">
      <template slot="title">
        Failed
      </template>
      <template slot="text">
        {{ errorMessage }}
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="saveFailed = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import AppModal from '@/components/generic/AppModal'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ImporterTimeSeriesSelector from '@/components/generic/ImporterTimeSeriesSelector'
  import ImporterGeneral from '@/components/Administration/ContinuousDataImportModal/ImporterGeneral'
  import ImporterAlert from '@/components/Administration/ContinuousDataImportModal/ImporterAlert'
  import ImporterConfigUtil from '@/components/mixins/ImporterConfigUtil'
  import ImporterStationSelector from '@/components/Administration/ContinuousDataImportModal/ImporterStationSelector'
  import { createNamespacedHelpers } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')
  const jdsMinColumnIndexValue = 2
  const jdsMinColumnIndexMessage = 'Inputted JDS column index must be >=2. Indices 0-1 are reserved columns for TIMESTAMP, and RECORD. Please input a value >=2'
  export default {
    components: {
      ImporterStationSelector,
      ImporterTimeSeriesSelector,
      ImporterGeneral,
      ImporterAlert,
      'app-modal': AppModal,
      'app-confirmation-modal': AppConfirmationModal,
    },
    mixins: [SnackBarUtil, ImporterConfigUtil],
    props: {
      importerId: {
        type: Number,
        default: 0,
      },
      value: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        valid: true,
        linkRuleNG: [
          (v) => this.columnIndexNullRepeatRule(v, this.NGConfig),
          (v) => this.intMinValueRule(v, jdsMinColumnIndexValue, jdsMinColumnIndexMessage),
        ],
        showLoading: false,
        btnLoading: false,
        saveFailed: false,
        errorMessage: '',
        model: 'tab-1',
        showModal: false,
        Name: '',
        Description: '',
        ExecuteInterval: '',
        StationName: '',
        StartRowIndex: '',
        NGConfig: [{
          TimeSeries: {},
          Index: null,
        }],
      }
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['ImporterConfigs', 'TimeSeries', 'AQUARIUS_SERVER_NG', 'IMPORTER_TYPE_JDS']),
      ImporterType() {
        return this.IMPORTER_TYPE_JDS
      },
      sharedCheck() {
        return this.StationName && this.StartRowIndex
      },
      mappingCheck() {
        return this.timeSeriesAndColumnIndexCheck
      },
      AlertNG() {
        return {
          Alert: this.showAlertTab('tab-1') || this.showAlertRepeatNG || this.IndexRepeatNG,
          Msg: this.NgAlertMsg(),
        }
      },
    },
    watch: {
      value(v) {
        this.updateFormValue(v)
      },
      showModal(v) {
        if (!v) {
          this.close()
        }
      },
    },
    methods: {
      ...continuousimporterconfig.mapActions(['addImporterConfig', 'updateImporterConfig', 'getImporterDetail']),
      async updateFormValue(v) {
        this.showModal = v
        if (this.showModal && this.importerId != 0) {
          this.showLoading = true
          let options = {
            data: this.importerId,
          }
          let result = await this.getImporterDetail(options)
          this.Name = result.Name
          this.Description = result.Description
          this.ExecuteInterval = result.ExecuteInterval
          this.StationName = result.StationName
          this.StartRowIndex = result.StartRowIndex
          this.NGConfig = result.NG_Config.TimeSeriesConfig.map(x => {
            return {
              Index: x.ColumnIndex,
              TimeSeries: {
                Id: Number(x.AquariusTimeSeriesId),
                TimeSeriesName: x.AquariusTimeSeriesIdentifier,
              },
            }
          })
          this.showLoading = false
        }
      },
      clearAll() {
        this.$refs.form.resetValidation()
        this.model = 'tab-1'
        this.Name = ''
        this.Description = ''
        this.ExecuteInterval = ''
        this.StationName = ''
        this.StartRowIndex = ''
        this.NGConfig = [{
          TimeSeries: {},
          Index: null,
        }]
      },
      save() {
        this.btnLoading = true
        let NG_Config = {
          TimeSeriesConfig: this.NGConfig.map(x => {
            return {
              ColumnIndex: x.Index,
              AquariusTimeSeriesId: x.TimeSeries.Id,
              AquariusTimeSeriesIdentifier: x.TimeSeries.TimeSeriesName,
            }
          }),
        }
        let options = {
          data: {
            Id: this.importerId,
            Name: this.Name,
            ImporterType: this.ImporterType,
            ExecuteInterval: this.ExecuteInterval,
            Description: this.Description,
            StationName: this.StationName,
            StartRowIndex: this.StartRowIndex,
            NG_Config: NG_Config,
          },
          successCb: () => {
            this.saveSuccess()
            this.btnLoading = false
            this.close()
          },
          failedCb: (err) => {
            this.btnLoading = false
            this.saveFailed = true
            this.errorMessage = err
          },
        }
        if (this.importerId) {
          this.updateImporterConfig(options)
        } else {
          this.addImporterConfig(options)
        }
      },
      setGeneralData(data) {
        this.Name = data.Name
        this.Description = data.Description
        this.ExecuteInterval = data.ExecuteInterval
      },
    },
    mounted() {
      this.clearAll()
      this.updateFormValue(this.value)
    },
  }
</script>

<style lang="stylus" scoped>
  .icon_border {
    border: 1px solid #e53935 !important;
  }
</style>